/**
 * Application entry. Resolves the canvas, runs the boot orchestrator, and
 * surfaces structured failures to the boot overlay so a missing WebGPU
 * stack never produces a silent black screen.
 */

import { boot } from './app/boot';
import { showError } from './app/errorScreen';
import { WebGpuUnavailableError } from './renderer/webgpu/device';
import { PresetValidationError } from './engine/presets/validate';

async function main(): Promise<void> {
  const canvas = document.getElementById('canvas');
  if (!(canvas instanceof HTMLCanvasElement)) {
    showError('Canvas missing', 'Could not find #canvas element on the page.');
    return;
  }

  try {
    await boot(canvas);
  } catch (err) {
    console.error('[boot] failed:', err);
    if (err instanceof WebGpuUnavailableError) {
      showError('WebGPU required', err.message);
    } else if (err instanceof PresetValidationError) {
      showError('Preset failed validation', err.message);
    } else {
      showError(
        'Unexpected error',
        err instanceof Error ? `${err.name}: ${err.message}` : String(err),
      );
    }
  }
}

void main();
